import React, { useEffect } from 'react';

// --- CSS STYLES FOR THE "POSTCARD PILE" DESIGN ---
const styles = `
  .postcard-destinations-section {
    padding: 6rem 0;
    /* A subtle textured background to simulate a surface */
    background-color: #e8e4d8;
    background-image: linear-gradient(45deg, rgba(255,255,255,.05) 25%, transparent 25%, transparent 75%, rgba(255,255,255,.05) 75%), linear-gradient(45deg, rgba(255,255,255,.05) 25%, transparent 25%, transparent 75%, rgba(255,255,255,.05) 75%);
    background-size: 60px 60px;
    background-position: 0 0, 30px 30px;
    font-family: 'Georgia', serif;
    overflow: hidden;
  }

  /* --- The container that holds the pile of cards --- */
  .postcard-pile {
    position: relative;
    width: 400px;
    height: 450px;
    margin: auto;
    /* This makes children position themselves relative to this container */
  }

  /* --- Individual Postcard Styles --- */
  .postcard {
    position: absolute;
    left: 0;
    top: 0;
    width: 300px;
    height: 380px;
    padding: 15px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.2);
    cursor: pointer;
    transition: transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), 
                box-shadow 0.4s ease, 
                z-index 0s 0.2s; /* Delay z-index change to prevent flickering */
  }
  
  .postcard-image {
      width: 100%;
      height: 80%;
      background-size: cover;
      background-position: center;
  }

  .postcard-title {
      font-size: 1.5rem;
      font-weight: bold;
      color: #333;
      text-align: center;
      margin-top: 15px;
  }

  /* --- The magic: position and rotate each card uniquely --- */
  .postcard-pile .postcard:nth-of-type(1) { transform: rotate(-8deg) translate(20px, 10px); }
  .postcard-pile .postcard:nth-of-type(2) { transform: rotate(5deg) translate(0, 30px); }
  .postcard-pile .postcard:nth-of-type(3) { transform: rotate(10deg) translate(50px, -5px); }
  .postcard-pile .postcard:nth-of-type(4) { transform: rotate(-3deg) translate(-20px, 40px); }
  .postcard-pile .postcard:nth-of-type(5) { transform: rotate(2deg) translate(30px, 15px); }
  
  /* --- The Hover Interaction --- */
  .postcard-pile:hover .postcard {
      transform: rotate(0deg) translate(0,0); /* Straighten out all cards slightly */
  }

  /* The specific card being hovered lifts up and centers */
  .postcard-pile .postcard:hover {
    z-index: 10;
    transform: scale(1.15) rotate(0deg) !important; /* !important overrides the general hover */
    box-shadow: 0 20px 40px rgba(0,0,0,0.3);
  }
`;

// --- The Card Component for the Postcard Pile ---
const Postcard = ({ image, name }) => (
  <div className="postcard">
    <div className="postcard-image" style={{ backgroundImage: `url(${image})` }}></div>
    <h3 className="postcard-title">{name}</h3>
  </div>
);

// --- The Main Section Component ---
const Destinations3 = () => {
  // Static data for the destinations.
  const destinations = [
    { image: 'https://images.pexels.com/photos/1285625/pexels-photo-1285625.jpeg', name: 'Paris' },
    { image: 'https://images.pexels.com/photos/753626/pexels-photo-753626.jpeg', name: 'Phuket' },
    { image: 'https://images.pexels.com/photos/208701/pexels-photo-208701.jpeg', name: 'Dubai' },
    { image: 'https://images.pexels.com/photos/2363/france-landmark-lights-night.jpg', name: 'Rome' },
    { image: 'https://images.pexels.com/photos/373945/pexels-photo-373945.jpeg', name: 'New York' },
  ];
  
  // Effect to inject the styles into the document head
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = styles;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  return (
    <section className="postcard-destinations-section">
      {/* Section Header */}
      <div className="container text-center mb-5">
        <h2 className="display-4 fw-bolder" style={{ color: '#4a4a4a' }}>A World of Memories</h2>
        <p className="lead" style={{ color: '#6b6b6b' }}>Pick a postcard from our collection of adventures.</p>
      </div>
      
      {/* The Postcard Pile Container */}
      <div className="postcard-pile">
        {destinations.map((dest, index) => (
          <Postcard key={index} {...dest} />
        ))}
      </div>
    </section>
  );
};

export default Destinations3;